import * as actions from './actions'
import { success, failure } from 'utilities/actions'

import type { Organisation } from 'types'

export type State = {
  data: Organisation[];
  errors: any[];
  loading: boolean;
};

type Action = {
  type: string;
  data?: Organisation[];
  errors?: any[];
};

export const initialState: State = {
  data: [],
  errors: [],
  loading: false
}

const reducer = (state: State, action: Action) => {
  if (state === undefined) { state = initialState }
  switch (action.type) {
    case actions.API_GRANTED_ORGANISATIONS_INDEX:
      return { ...state, loading: true }
    case success(actions.API_GRANTED_ORGANISATIONS_INDEX):
      return { ...state, data: action.data, loading: false }
    case failure(actions.API_GRANTED_ORGANISATIONS_INDEX):
      return { ...state, errors: action.errors, loading: false }
    default:
      return state
  }
}

export default reducer
